import React, { useState, useEffect, useRef } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Button from "@mui/material/Button";
import Paper from "@mui/material/Paper";
import { Link, useParams } from "react-router-dom";
import axios from "../Axiosinstance";
import { PDFDocument, rgb, StandardFonts } from "pdf-lib";
import { saveAs } from "file-saver";
import pdfTemplate from "./registration-receipt.pdf";
import logo from "../Batchescourserun/Juro.png";
import calibriFont1 from "../fonts/calibri.ttf";
import calibriFont from "../fonts/calibri.ttf";
import fontkit from "@pdf-lib/fontkit";
import DownloadIcon from "@mui/icons-material/Download";
import PaymentLoader from "../Loader";
import instalment from "../pdf/instalment-receipt.pdf";
import { removeBracketedText } from "../Axiosinstance";
import ArialItalicBold from '../fonts/ArialCEBoldItalic.ttf';

import calibriFontItalic from "../fonts/calibri-italic.ttf";
import calibriFontBold from "../fonts/CalibriBold.ttf";

const InvoiceStudent = () => {
  const apiCallInProgress = useRef(false);
  const { studentid } = useParams();
  const [studentInfo, setStudentInfo] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [firstInfocall, setFirstInfocall] = useState(null);
  const [secondInfocall, setSecondInfocall] = useState(null);
  const [shouldRenderReceipt, setShouldRenderReceipt] = useState(0);


  const id = studentid.split("_")[2];

  const invoiceData = {
    companyName: "JURONG ACADEMY",
    companyAddress:
      "134 Jurong Gateway Road,#03-307L (Head Office),Singapore 600134",
    companyPhone: "(65) 6635 5724",
    companyEmail: "ask@ja.edu.sg",
    companyWebsite: "https://ja.edu.sg",

    invoiceNumber: "01-112",
    modeOfPayment: "Wire transfer",
  };

  // let apiCallInProgress = false;

  useEffect(() => {
    const updateStatusAndFetchStudent = async () => {
      if (apiCallInProgress.current) {
        return; // Prevent multiple concurrent calls
      }

      apiCallInProgress.current = true;
      setLoading(true);

      try {
        const response = await axios.get(`/registrationadvances/info/${id}`);
        setSecondInfocall(response.data);
        // Await the post call to ensure it completes before proceeding
        const courseFeeResponse = await axios.post(`/registrationadvances/${id}/course-fee-details`, {
          sessionId: "HELLO WORLD",
          sessionDate: new Date().toISOString().split("T")[0],
          amount: response.data.paymentAmount,
          paymentMode: "online",
          remarks: "",
        });

        setShouldRenderReceipt(courseFeeResponse.data.currentPaid);

        // You can now use courseFeeResponse.data

        const approveResponse = await axios.post(`/registrationadvances/${id}/approveout`);

        const response1 = await axios.get(`/registrationadvances/info/${id}`);

        console.log("response.data.paymentAmount", response);
        setSecondInfocall(response1.data);
        setStudentInfo(response1.data);

        // // Compare installmentsPaid length
        // const firstLength = response.data.installmentsPaid?.length || 0;
        // const secondLength = response1.data.installmentsPaid?.length || 0;

        // if (secondLength > firstLength) {

        // } else {
        //   setShouldRenderReceipt(false);
        // }
      } catch (err) {
        setError(err);
        console.error("Error:", err);
      } finally {
        apiCallInProgress.current = false;
        setLoading(false);
      }
    };

    if (id) {
      updateStatusAndFetchStudent();
    }
  }, [id]);

  useEffect(() => {
    const sendReceipts = async () => {
      if (studentInfo) {
        try {
          await Promise.all([
            axios.post(`/registrationadvances/send-receipt/${id}`),
            axios.post(`/registrationadvances/send-receipts/${id}`),
          ]);
        } catch (err) {
          setError(err);
          console.error("Error:", err);
        }
      }
    };

    sendReceipts();
  }, [studentInfo, id]);

  useEffect(() => {
    const fetchInvoiceDetails = async () => {
      if (studentInfo) {
        try {
          const response = await axios.get(
            `/registrationadvances/detailsForSendInvoice/${id}`
          );
        } catch (err) {
          setError(err);
          console.error("Error:", err);
        }
      }
    };

    fetchInvoiceDetails();
  }, [studentInfo, id]);

  if (loading) {
    return (
      <div>
        <PaymentLoader />
      </div>
    );
  }

  const numberToWords = (number) => {
    const ones = [
      "",
      "one",
      "two",
      "three",
      "four",
      "five",
      "six",
      "seven",
      "eight",
      "nine",
    ];
    const teens = [
      "",
      "eleven",
      "twelve",
      "thirteen",
      "fourteen",
      "fifteen",
      "sixteen",
      "seventeen",
      "eighteen",
      "nineteen",
    ];
    const tens = [
      "",
      "ten",
      "twenty",
      "thirty",
      "forty",
      "fifty",
      "sixty",
      "seventy",
      "eighty",
      "ninety",
    ];
    const suffixes = ["", "thousand"];

    const numToWords = (num) => {
      let words = "";
      if (num >= 1000) {
        words += numToWords(Math.floor(num / 1000)) + " thousand ";
        num %= 1000;
      }
      if (num >= 100) {
        words += ones[Math.floor(num / 100)] + " hundred ";
        num %= 100;
      }
      if (num >= 20) {
        words += tens[Math.floor(num / 10)] + " ";
        num %= 10;
      }
      if (num > 0) {
        if (num >= 11 && num <= 19) {
          words += teens[num - 10] + " ";
        } else {
          words += ones[num] + " ";
        }
      }
      return words.trim();
    };

    if (number === 0) return "zero";
    return numToWords(number);
  };
  const toUpperCaseString = (str) => {
    return str?.toUpperCase();
  };

  const getMonthName = (monthNumber) => {
    const monthNames = [
      "JANUARY",
      "FEBRUARY",
      "MARCH",
      "APRIL",
      "MAY",
      "JUNE",
      "JULY",
      "AUGUST",
      "SEPTEMBER",
      "OCTOBER",
      "NOVEMBER",
      "DECEMBER",
    ];
    return monthNames[monthNumber];
  };

  const toUpperCaseString1 = (str) => {
    // Remove trailing numbers within parentheses
    return str?.replace(/\(\d+\)$/, "").toUpperCase();
  };

  // Function to get the last two digits of the year from a date string
  const getYear = (dateString) => {
    const date = new Date(dateString);
    return date.getFullYear().toString().slice(-2); // Get last two digits of the year
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date?.getDate()).padStart(2, '0');
    const month = String(date?.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  function formatCustomDate(date) {
    const day = String(date?.getDate()).padStart(2, "0");
    const month = String(date?.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
    const year = date?.getFullYear();
    return `${day}/${month}/${year}`;
  }

  const scheduleDateforintake = new Date(studentInfo?.startModuleDate);
  const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  const formattedDateIntake = `${monthNames[scheduleDateforintake?.getMonth()]
    } ${scheduleDateforintake.getFullYear()}`;

  const registrationFee =
    studentInfo?.installmentsPaid?.length > 0
      ? studentInfo?.installmentsPaid[studentInfo?.installmentsPaid.length - 1]
        .amount
      : 0;
  const sequenceNumber =
    studentInfo?.installmentsPaid?.length > 0
      ? studentInfo?.installmentsPaid[studentInfo?.installmentsPaid.length - 1]
        .sequenceNumber
      : 0;
  const totalAmount = registrationFee / 1.09;
  const gst = registrationFee - totalAmount;
  const sumOfDollars = numberToWords(registrationFee);
  {
    studentInfo?.courseFeeDetails[
      studentInfo?.courseFeeDetails.length - 1
    ]?.amount.toFixed(2)
  }
  const sumOfDollarsCourseFee = numberToWords(studentInfo?.courseFeeDetails[
    studentInfo?.courseFeeDetails.length - 1
  ]?.amount.toFixed(2));


  const registrationFee1 =
    studentInfo?.courseFeeDetails?.length > 0
      ? studentInfo?.courseFeeDetails[studentInfo?.courseFeeDetails.length - 1]
        .amount
      : 0;
  const totalAmount1 = registrationFee1 / 1.09;
  const gst1 = registrationFee1 - totalAmount1;
  const sumOfDollars1 = numberToWords(registrationFee1);
  const paymentType = studentInfo?.paymentType === "online" ? "(OMT)" : "";

  const formValues = {
    // invoiceNo: `INVJA${studentInfo?.id}`, // Example: INVJA2
    date: formatCustomDate(
      studentInfo?.late
        ? studentInfo?.installmentsPaid?.length === 1
          ? studentInfo?.scheduleDate
            ? new Date(studentInfo.scheduleDate)
            : undefined
          : studentInfo?.installmentsPaid?.[studentInfo?.installmentsPaid?.length - 1]?.sessionDate
            ? new Date(
              studentInfo.installmentsPaid[
                studentInfo.installmentsPaid.length - 1
              ].sessionDate
            )
            : undefined
        : studentInfo?.installmentsPaid?.[studentInfo?.installmentsPaid?.length - 1]?.sessionDate
          ? new Date(
            studentInfo.installmentsPaid[
              studentInfo.installmentsPaid.length - 1
            ].sessionDate
          )
          : undefined
    ),
    studentName: toUpperCaseString(`${studentInfo?.name} `),
    nric: studentInfo?.nric, // Assuming you have this field in studentInfo
    course: toUpperCaseString1(studentInfo?.course), // Assuming you have this field in studentInfo
    intake: toUpperCaseString(formattedDateIntake), // Assuming you have this field in studentInfo
    registrationFees: registrationFee?.toFixed(2), // Assuming registrationFee is a number
    gst: `$${gst?.toFixed(2)} )`, // Example static value for GST
    balance: `${studentInfo?.registrationFeeRemaining}`, // Assuming registrationFeeRemaining is a number
    sumOfDollars: toUpperCaseString(`${sumOfDollars} DOLLARS ONLY`), // Assuming totalPaidAmount is a number
    total: `$${registrationFee?.toFixed(2)}`,
    //  name: 'John Smith',
    registrationFee: `$${registrationFee?.toFixed(2)}`,
    approver: toUpperCaseString1(studentInfo?.approver) || "",
    sequenceNumber: sequenceNumber
  };
  console.log(formValues.date);
  const formValues1 = {
    // invoiceNo: `INVJA${studentInfo?.id}`, // Example: INVJA2
    date: new Date(studentInfo?.sessionDate).toLocaleDateString(),
    studentName: toUpperCaseString(`${studentInfo?.name}`),
    nric: studentInfo?.nric, // Assuming you have this field in studentInfo
    course: toUpperCaseString1(studentInfo?.course), // Assuming you have this field in studentInfo
    intake: toUpperCaseString(formattedDateIntake), // Assuming you have this field in studentInfo
    registrationFees1: registrationFee1?.toFixed(2), // Assuming registrationFee is a number
    gst1: `${gst1?.toFixed(2)} )`, // Example static value for GST
    balance: `${studentInfo?.courseFeeRemaining}`, // Assuming registrationFeeRemaining is a number
    sumOfDollars: toUpperCaseString(`${sumOfDollars1} DOLLARS ONLY`), // Assuming totalPaidAmount is a number
    total: `$${registrationFee1.toFixed(2)}`,
    //  name: 'John Smith',
    registrationFee1: registrationFee1?.toFixed(2),
    approver: toUpperCaseString1(studentInfo?.approver) || "",
    paymentType: toUpperCaseString1(studentInfo?.paymentType) || "",
    installment:
      studentInfo?.installmentsPaid[studentInfo?.installmentsPaid.length - 1]
        .installmentCount,
  };

  if (error) {
    return <div>Error: {error.message}</div>; // Error state
  }

  const toUpperCaseString11 = (dateString) => {
    const date = new Date(dateString);
    const month = getMonthName(date?.getMonth());
    const year = date.getFullYear();
    return `${month} ${year}`;
  };

  const handlePdfEdit = async () => {
    try {
      // Fetch the static PDF
      const pdfBytes = await fetch(pdfTemplate).then((res) =>
        res.arrayBuffer()
      );
      const pdfDoc = await PDFDocument.load(pdfBytes);
      const pages = pdfDoc.getPages();
      const firstPage = pages[0];
      pdfDoc.registerFontkit(fontkit);

      const calibriFontBoldBytes = await fetch(calibriFontBold).then((res) =>
        res.arrayBuffer()
      );
      const calibriFontBoldEmbed = await pdfDoc.embedFont(calibriFontBoldBytes);

      const calibriFontItalicBytes = await fetch(calibriFontItalic).then(
        (res) => res.arrayBuffer()
      );
      const calibriFontItalicEmbed = await pdfDoc.embedFont(
        calibriFontItalicBytes
      );

      // Register fontkit
      pdfDoc.registerFontkit(fontkit);

      // Load the Calibri font
      const calibriBytes = await fetch(calibriFont).then((res) =>
        res.arrayBuffer()
      );
      const calibriFontEmbed = await pdfDoc.embedFont(calibriBytes);

      const drawTextSafe = (text, options) => {
        if (text) {
          firstPage.drawText(text.toString(), options);
        }
      };

      const drawTextWithUnderline = async (text, options) => {
        if (text) {
          const { x, y, size, font } = options;

          // Draw the text
          firstPage.drawText(text.toString(), options);

          // Calculate text width
          const textWidth = font.widthOfTextAtSize(text.toString(), size);

          // Draw the underline
          firstPage.drawLine({
            start: { x, y: y - 2 }, // Adjust y to position the underline
            end: { x: x + textWidth, y: y - 2 }, // End x position based on text width
            thickness: 0.5, // Line thickness
            color: rgb(0, 0, 0), // Line color (black)
          });
        }
      };

      firstPage.drawText(`TAX INVOICE`, {
        x: 420,
        y: 775,
        size: 19,
        font: calibriFontBoldEmbed,
        color: rgb(0, 0, 0),
      });
      firstPage.drawText(`GST No. 201322342Z`, {
        x: 420,
        y: 760,
        size: 12,
        font: calibriFontEmbed,
        color: rgb(0, 0, 0),
      });

      drawTextSafe("OFFICIAL INVOICE NO:", {
        x: 360,
        y: 675,
        size: 9,
        font: calibriFontBoldEmbed,
        color: rgb(0, 0, 0),
      });
      // Insert values from form
      drawTextWithUnderline(
        `JA${getYear(studentInfo.date)}-${String(formValues.sequenceNumber).padStart(4, '0')
        }-${studentInfo.nric
        }-R`,
        {
          x: 445,
          y: 675,
          size: 9,
          font: calibriFontBoldEmbed,
          color: rgb(0, 0, 0),
        }
      );
      drawTextSafe(formValues.date, {
        x: 383.5,
        y: 666,
        size: 9,
        font: calibriFontBoldEmbed,
        color: rgb(0, 0, 0),
      });
      drawTextSafe(formValues.studentName, {
        x: 184,
        y: 641.6,
        size: 9,
        font: calibriFontBoldEmbed,
        color: rgb(0, 0, 0),
      });
      drawTextSafe(formValues.nric, {
        x: 184,
        y: 629.3,
        size: 9,
        font: calibriFontBoldEmbed,
        color: rgb(0, 0, 0),
      });
      drawTextSafe(formValues.course, {
        x: 184,
        y: 617,
        size: 9,
        font: calibriFontBoldEmbed,
        color: rgb(0, 0, 0),
      });
      drawTextSafe(formValues.intake, {
        x: 184,
        y: 605,
        size: 9,
        font: calibriFontBoldEmbed,
        color: rgb(0, 0, 0),
      });
      // drawTextSafe(`${registrationFee}`, {
      //   x: 144,
      //   y: 555,
      //   size: 9,
      //   font: calibriFontEmbed,
      //   color: rgb(0, 0, 0),
      // });
      let displayFee;
      if (studentInfo?.paymentType === 'online') {
        displayFee = `${registrationFee} (OMT)`;
      } else {
        displayFee = `${registrationFee}`;
      }
      drawTextSafe(displayFee, {
        x: 144,
        y: 555,
        size: 9,
        font: calibriFontEmbed,
        color: rgb(0, 0, 0),
      });
      // if (paymentType) {
      //   drawTextSafe(`${paymentType}`, {
      //     x: 168,
      //     y: 555,
      //     size: 9,
      //     font: calibriFontEmbed,
      //     color: rgb(0, 0, 0),
      //   });
      // }
      drawTextSafe(formValues.gst, {
        x: 153,
        y: 544,
        size: 10,
        font: calibriFontItalicEmbed,
        color: rgb(0, 0, 0),
      });
      drawTextSafe(formValues.balance, {
        x: 110,
        y: 522,
        size: 9,
        color: rgb(0, 0, 0),
      });
      drawTextSafe(formValues.sumOfDollars, {
        x: 131.5,
        y: 495,
        font: calibriFontEmbed,
        size: 9,
        color: rgb(0, 0, 0),
      });
      drawTextSafe(`$${registrationFee}`, {
        x: 478,
        y: 493,
        font: calibriFontBoldEmbed,
        size: 9,
        color: rgb(0, 0, 0),
      });
      drawTextSafe(`$${registrationFee}`, {
        x: 478,
        y: 565,
        font: calibriFontEmbed,
        size: 9,
        color: rgb(0, 0, 0),
      });
      drawTextSafe(formValues.installment, {
        x: 478,
        y: 493,
        font: calibriFontBoldEmbed,
        size: 9,
        color: rgb(0, 0, 0),
      });

      firstPage.drawText(
        "This is computer generated document no signature required.",
        {
          x: 69,
          y: 450,
          size: 9,
          font: calibriFontBoldEmbed,
          color: rgb(0, 0, 0),
        }
      );

      const pdfBytesEdited = await pdfDoc.save();
      const blob = new Blob([pdfBytesEdited], { type: "application/pdf" });

      saveAs(
        blob,
        `${toUpperCaseString(studentInfo.name)} -REGISTRATION-RECEIPT.pdf`
      );
    } catch (error) {
      console.error("Error editing PDF:", error);
    }
  };

  const getOrdinalSuffix = (number) => {
    if (number === 1) {
      return "st ";
    } else if (number === 2) {
      return "nd ";
    } else if (number === 3) {
      return "rd ";
    } else {
      return "th ";
    }
  };

  // const isMobileOrTablet = window.innerWidth <= 768;

  // Safely accessing the last course detail and its installment counts
  const lastCourseDetail =
    studentInfo?.courseFeeDetails?.[studentInfo?.courseFeeDetails?.length - 1];
  const lastInstallmentCount = lastCourseDetail?.installmentCounts ?? [];
  const lastInstallment =
    lastInstallmentCount?.[lastInstallmentCount?.length - 1] ?? 0;

  // Safely generating installment count text
  const installmentCountText =
    lastInstallmentCount.length === 1
      ? `${lastInstallmentCount[0] ?? 0}${getOrdinalSuffix(
        lastInstallmentCount[0] ?? 0
      )}`
      : `${lastInstallmentCount[0] ?? 0}${getOrdinalSuffix(
        lastInstallmentCount[0] ?? 0
      )},${lastInstallment ?? 0}${getOrdinalSuffix(lastInstallment ?? 0)}`;

  // Safely calculating the amount difference
  const getwithnum = lastCourseDetail?.amount
    ? (lastCourseDetail.amount - lastCourseDetail.amount / 1.09).toFixed(2)
    : "0.00";

  // Safely calculating the remaining balance
  const balanceDue = lastCourseDetail?.courseFeeRemaining?.toFixed(2) ?? "0.00";

  function dateformat(dateStr) {
    const date = new Date(dateStr);
    return date.toLocaleDateString("en-US");
  }


  const handlePdfEdit1 = async () => {
    try {
      // Fetch the static PDF
      const pdfBytes = await fetch(instalment).then((res) => res.arrayBuffer());
      const pdfDoc = await PDFDocument.load(pdfBytes);
      const pages = pdfDoc.getPages();
      const firstPage = pages[0];
      pdfDoc.registerFontkit(fontkit);

      const calibriFontBoldBytes = await fetch(calibriFontBold).then((res) =>
        res.arrayBuffer()
      );
      const calibriFontBoldEmbed = await pdfDoc.embedFont(calibriFontBoldBytes);

      const calibriFontItalicBytes = await fetch(calibriFontItalic).then(
        (res) => res.arrayBuffer()
      );
      const calibriFontItalicEmbed = await pdfDoc.embedFont(
        calibriFontItalicBytes
      );

      const calibriFontItalicBoldBytes = await fetch(ArialItalicBold).then((res) => res.arrayBuffer());
      const calibriFontItalicBoldEmbed = await pdfDoc.embedFont(calibriFontItalicBoldBytes);

      // Register fontkit
      pdfDoc.registerFontkit(fontkit);

      // Load the Calibri font
      const calibriBytes = await fetch(calibriFont).then((res) =>
        res.arrayBuffer()
      );
      const calibriFontEmbed = await pdfDoc.embedFont(calibriBytes);

      const drawTextSafe = (text, options) => {
        if (text) {
          firstPage.drawText(text.toString(), options);
        }
      };

      const drawTextWithUnderline = async (text, options) => {
        if (text) {
          const { x, y, size, font } = options;

          // Draw the text
          firstPage.drawText(text.toString(), options);

          // Calculate text width
          const textWidth = font.widthOfTextAtSize(text.toString(), size);

          // Draw the underline
          firstPage.drawLine({
            start: { x, y: y - 2 }, // Adjust y to position the underline
            end: { x: x + textWidth, y: y - 2 }, // End x position based on text width
            thickness: 0.5, // Line thickness
            color: rgb(0, 0, 0), // Line color (black)
          });
        }
      };

      // Insert values from form
      drawTextWithUnderline(
        `JAO/CF-${getYear(studentInfo?.startModuleDate)}-${String(studentInfo?.sequenceNumber).padStart(4, '0')
        }`,
        {
          x: 455,
          y: 644.3,
          size: 9,
          font: calibriFontBoldEmbed,
          color: rgb(0, 0, 0),
        }
      );
      drawTextSafe(formatDate(lastCourseDetail?.sessionDate), {
        x: 389,
        y: 629.5,
        size: 9,
        font: calibriFontBoldEmbed,
        color: rgb(0, 0, 0),
      });
      drawTextSafe(formValues1?.studentName, {
        x: 184,
        y: 618,
        size: 9,
        font: calibriFontBoldEmbed,
        color: rgb(0, 0, 0),
      });
      drawTextSafe(formValues1?.nric, {
        x: 184,
        y: 607.5,
        size: 9,
        font: calibriFontBoldEmbed,
        color: rgb(0, 0, 0),
      });
      drawTextSafe(formValues1?.course, {
        x: 184,
        y: 596,
        size: 9,
        font: calibriFontBoldEmbed,
        color: rgb(0, 0, 0),
      });
      drawTextSafe(`${toUpperCaseString11(studentInfo?.startModuleDate)}`, {
        x: 184,
        y: 585.6,
        size: 9,
        font: calibriFontBoldEmbed,
        color: rgb(0, 0, 0),
      });
      drawTextSafe(`$${getwithnum})`, {
        x: 183,
        y: 530,
        size: 9,
        font: calibriFontItalicBoldEmbed,
        color: rgb(0, 0, 0),
      });
      drawTextSafe(`$${lastCourseDetail?.courseFeeRemaining}`, {
        x: 153,
        y: 507.5,
        size: 9,
        font: calibriFontItalicEmbed,
        color: rgb(0, 0, 0),
      });
      drawTextSafe(formValues1?.sumOfDollars, {
        x: 143.5,
        y: 473.8,
        font: calibriFontBoldEmbed,
        size: 9,
        color: rgb(0, 0, 0),
      });

      //first amount right side
      drawTextSafe(`$${registrationFee1}`, {
        x: 478,
        y: 553,
        font: calibriFontBoldEmbed,
        size: 9,
        color: rgb(0, 0, 0),
      });
      drawTextSafe(`${registrationFee1}`, {
        x: 486,
        y: 475,
        font: calibriFontBoldEmbed,
        size: 9,
        color: rgb(0, 0, 0),
      });

      firstPage.drawText(
        "This is computer generated document no signature required.",
        {
          x: 75,
          y: 420,
          size: 9,
          font: calibriFontBoldEmbed,
          color: rgb(0, 0, 0),
        }
      );

      // drawTextSafe(formValues1?.registrationFee1, { x: 478, y: 565, font: calibriFontEmbed, size: 9, color: rgb(0, 0, 0) });
      drawTextSafe(
        `${installmentCountText} Instalment $${registrationFee1} (OMT)`,
        {
          x: 79,
          y: 540.8,
          size: 9,
          font: calibriFontItalicBoldEmbed,
          color: rgb(0, 0, 0),
        }
      );
      let installmentText = "";
      let balanceText = "";

      if (
        studentInfo?.courseFeeDetails[studentInfo?.courseFeeDetails.length - 1]
          .remainingBalance !== 0
      ) {
        balanceText =
          lastInstallment + getOrdinalSuffix(lastInstallment) + " Balance, ";
      }

      // Only display the installment if the next installment number is not 13
      // if (lastInstallment + 1 !== 13) {
      //   installmentText =
      //     lastInstallment +
      //     1 +
      //     getOrdinalSuffix(lastInstallment + 1) +
      //     " Installment";
      // }
      if (studentInfo.type == "diploma") {
        // Only display the installment if the next installment number is not 13
        if (lastInstallment + 1 !== 13) {
          installmentText =
            lastInstallment +
            1 +
            getOrdinalSuffix(lastInstallment + 1) +
            " Installment";
        }
      }
      else {
        if (lastInstallment + 1 !== 7) {
          installmentText =
            lastInstallment +
            1 +
            getOrdinalSuffix(lastInstallment + 1) +
            " Installment";
        }
      }


      drawTextSafe(balanceText + installmentText, {
        x: 193,
        y: 496.5,
        font: calibriFontItalicBoldEmbed,
        size: 9,
        color: rgb(0, 0, 0),
      });

      // const pdfBytesEdited = await pdfDoc.save();
      // const blob = new Blob([pdfBytesEdited], { type: 'application/pdf' });

      // saveAs(blob, `${toUpperCaseString(studentInfo?.name)}-INSTALMENT-RECEIPT.pdf`);

      const pdfBytesEdited = await pdfDoc.save();

      const pdfBlob = new Blob([pdfBytesEdited], { type: "application/pdf" });
      const pdfUrl = URL.createObjectURL(pdfBlob);
      window.open(pdfUrl, "_blank");
    } catch (error) {
      console.error("Error editing PDF:", error);
    }
  };

  return (
    <div
      className="receipt-container"
      style={{ display: "flex", justifyContent: "space-between" }}
    >
      {/* Conditionally render registration receipt */}
      {(shouldRenderReceipt === 1 || shouldRenderReceipt === 3) && (
        <div
          className="container-fluid"
          style={{
            // maxWidth: isMobileOrTablet ? '100%' : '50%',
            margin: "20px",
            padding: "20px",
            fontFamily: "Calibri, sans-serif",
            fontSize: "16px",
          }}
        >
          <div style={{ textAlign: "center", marginBottom: "20px" }}>
            <img
              src={logo}
              alt="Company Logo"
              style={{ width: "350px", marginBottom: "10px" }}
            />
            <p>{invoiceData.companyAddress}</p>
            <p>
              {invoiceData.companyPhone}, {invoiceData.companyEmail},{" "}
              {invoiceData.companyWebsite}
            </p>
          </div>
          {/* <Link to='/Dashboard'>back</Link> */}
          <div
            style={{
              border: "1px solid #ccc",
              padding: "20px",
              borderRadius: "5px",
              boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
            }}
          >
            <h2 style={{ marginBottom: "20px" }}>Invoice</h2>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                flexWrap: "wrap",
              }}
            >
              <div style={{ flex: "1", minWidth: "300px" }}>
                <table
                  style={{
                    width: "100%",
                    borderCollapse: "collapse",
                    marginBottom: "20px",
                  }}
                >
                  <tbody>
                    <tr style={{ borderBottom: "none" }}>
                      <td style={{ padding: "8px", fontSize: "15px" }}>
                        <strong>Received from</strong>
                      </td>
                      <td style={{ padding: "8px", fontSize: "15px" }}></td>
                    </tr>
                    <tr style={{ borderBottom: "none" }}>
                      <td style={{ padding: "8px", fontSize: "15px" }}>
                        <strong>Student Name</strong>
                      </td>
                      <td style={{ padding: "8px", fontSize: "15px" }}>
                        : {`${studentInfo.name}`}
                      </td>
                    </tr>
                    <tr style={{ borderBottom: "none" }}>
                      <td style={{ padding: "8px", fontSize: "15px" }}>
                        <strong>FIN/NRIC/Passport No</strong>
                      </td>
                      <td style={{ padding: "8px", fontSize: "15px" }}>
                        : {studentInfo.nric}
                      </td>
                    </tr>
                    <tr style={{ borderBottom: "none" }}>
                      <td style={{ padding: "8px", fontSize: "15px" }}>
                        <strong>Course</strong>
                      </td>
                      <td style={{ padding: "8px", fontSize: "15px" }}>
                        :{" "}
                        {removeBracketedText(studentInfo.course.toUpperCase())}
                      </td>
                    </tr>
                    <tr style={{ borderBottom: "none" }}>
                      <td style={{ padding: "8px", fontSize: "15px" }}>
                        <strong>Intake</strong>
                      </td>
                      <td style={{ padding: "8px", fontSize: "15px" }}>
                        : {formattedDateIntake.toUpperCase()}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div style={{ flex: "1", minWidth: "300px", textAlign: "right" }}>
                <table
                  className="mobile-wrap-table"
                  style={{
                    width: "100%",
                    borderCollapse: "collapse",
                    marginBottom: "20px",
                  }}
                >
                  <tbody>
                    <tr style={{ borderBottom: "none" }}>
                      <td style={{ padding: "8px", fontSize: "15px" }}>
                        <strong>OFFICIAL INVOICE NO</strong>
                      </td>
                      <td
                        style={{
                          padding: "8px",
                          fontSize: "15px",
                          textDecoration: "underline",
                        }}
                      >
                        : JA{getYear(studentInfo.date)}-{String(formValues.sequenceNumber).padStart(4, '0')}-
                        {studentInfo.nric}-R
                      </td>
                    </tr>
                    <tr style={{ borderBottom: "none" }}>
                      <td style={{ padding: "8px", fontSize: "15px" }}>
                        <strong>Date</strong>
                      </td>
                      <td style={{ padding: "8px", fontSize: "15px" }}>
                        :{" "}
                        {new Date(
                          studentInfo?.installmentsPaid?.[studentInfo?.installmentsPaid.length - 1]?.sessionDate
                        ).toLocaleDateString("en-GB")}

                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <TableContainer component={Paper} style={{ marginBottom: "20px" }}>
              <Table sx={{ width: "100%" }} aria-label="spanning table">
                <TableHead>
                  <TableRow>
                    <TableCell>Item</TableCell>
                    <TableCell align="right">Quantity</TableCell>
                    <TableCell align="right">Total Amount</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow>
                    <TableCell>
                      Being Payment for:
                      <br />
                      Registration Fees:{" "}
                      <strong>
                        $
                        {
                          studentInfo?.installmentsPaid[
                            studentInfo?.installmentsPaid.length - 1
                          ].amount
                        }
                      </strong>
                      {studentInfo?.paymentType === "online" ? "(OMT)" : ""}
                      <br />
                      <strong>
                        <i>
                          (Inclusive of GST 9% - $
                          {(registrationFee - registrationFee / 1.09).toFixed(
                            2
                          )}
                          )
                        </i>
                      </strong>
                      <br />
                      <br />
                      Balance: $
                      {studentInfo?.registrationFeeRemaining.toFixed(2)}
                    </TableCell>
                    <TableCell align="right">1</TableCell>
                    <TableCell align="right">
                      {studentInfo?.installmentsPaid[
                        studentInfo?.installmentsPaid.length - 1
                      ].amount.toFixed(2)}
                    </TableCell>
                  </TableRow>
                  <TableRow style={{ backgroundColor: "#f2f2f2" }}>
                    <TableCell colSpan={2} align="left">
                      Sum of Dollars:{" "}
                      <strong>
                        {toUpperCaseString(`${sumOfDollars} DOLLOR ONLY`)}
                      </strong>
                    </TableCell>
                    <TableCell align="right">
                      {studentInfo?.installmentsPaid[
                        studentInfo?.installmentsPaid.length - 1
                      ].amount.toFixed(2)}
                    </TableCell>
                  </TableRow>
                  {/* <TableRow>
                    <TableCell colSpan={2}>
                      Name:<strong>{toUpperCaseString(studentInfo.approver)}</strong>
                    </TableCell>
                    <TableCell>
                      Signature:
                    </TableCell>
                  </TableRow> */}
                </TableBody>
              </Table>
            </TableContainer>

            <Button
              variant="contained"
              color="primary"
              startIcon={<DownloadIcon />}
              onClick={handlePdfEdit}
              style={{
                padding: "10px 20px",
                fontSize: "16px",
                borderRadius: "8px",
              }}
            >
              Download Receipt
            </Button>
          </div>
        </div>
      )}

      {/* Conditionally render course receipt */}
      {(shouldRenderReceipt === 2 || shouldRenderReceipt === 3) && studentInfo?.courseFeeDetails.length > 0 && (
        <div
          className="container-fluid"
          style={{
            margin: "20px",
            padding: "20px",
            fontFamily: "Calibri, sans-serif",
            fontSize: "16px",
          }}
        >
          <div style={{ textAlign: "center", marginBottom: "20px" }}>
            <img
              src={logo}
              alt="Company Logo"
              style={{ width: "350px", marginBottom: "10px" }}
            />
            <p>{invoiceData.companyAddress}</p>
            <p>
              {invoiceData.companyPhone}, {invoiceData.companyEmail},{" "}
              {invoiceData.companyWebsite}
            </p>
          </div>

          {/* <Link to='/Dashboard'>back</Link> */}
          <div
            style={{
              border: "1px solid #ccc",
              padding: "20px",
              borderRadius: "5px",
              boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
            }}
          >
            <h2 style={{ marginBottom: "20px" }}>Invoice</h2>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                flexWrap: "wrap",
              }}
            >
              <div style={{ flex: "1", minWidth: "300px" }}>
                <table
                  style={{
                    width: "100%",
                    borderCollapse: "collapse",
                    marginBottom: "20px",
                  }}
                >
                  <tbody>
                    <tr style={{ borderBottom: "none" }}>
                      <td style={{ padding: "8px", fontSize: "15px" }}>
                        <strong>Received from</strong>
                      </td>
                      <td style={{ padding: "8px", fontSize: "15px" }}></td>
                    </tr>
                    <tr style={{ borderBottom: "none" }}>
                      <td style={{ padding: "8px", fontSize: "15px" }}>
                        <strong>Student Name</strong>
                      </td>
                      <td style={{ padding: "8px", fontSize: "15px" }}>
                        : {`${studentInfo.name}`}
                      </td>
                    </tr>
                    <tr style={{ borderBottom: "none" }}>
                      <td style={{ padding: "8px", fontSize: "15px" }}>
                        <strong>FIN/NRIC/Passport No</strong>
                      </td>
                      <td style={{ padding: "8px", fontSize: "15px" }}>
                        : {studentInfo.nric}
                      </td>
                    </tr>
                    <tr style={{ borderBottom: "none" }}>
                      <td style={{ padding: "8px", fontSize: "15px" }}>
                        <strong>Course</strong>
                      </td>
                      <td style={{ padding: "8px", fontSize: "15px" }}>
                        :{" "}
                        {removeBracketedText(studentInfo.course.toUpperCase())}
                      </td>
                    </tr>
                    <tr style={{ borderBottom: "none" }}>
                      <td style={{ padding: "8px", fontSize: "15px" }}>
                        <strong>Intake</strong>
                      </td>
                      <td style={{ padding: "8px", fontSize: "15px" }}>
                        : {formattedDateIntake.toUpperCase()}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div style={{ flex: "1", minWidth: "300px", textAlign: "right" }}>
                <table
                  className="mobile-wrap-table"
                  style={{
                    width: "100%",
                    borderCollapse: "collapse",
                    marginBottom: "20px",
                  }}
                >
                  <tbody>
                    <tr style={{ borderBottom: "none" }}>
                      <td style={{ padding: "8px", fontSize: "15px" }}>
                        <strong>Official Invoice Number</strong>
                      </td>
                      <td
                        style={{
                          padding: "8px",
                          fontSize: "15px",
                          textDecoration: "underline",
                        }}
                      >
                        : JAO/CF-{getYear(studentInfo?.startModuleDate)}-
                        {String(studentInfo?.sequenceNumber).padStart(4, '0')}
                      </td>
                    </tr>
                    <tr style={{ borderBottom: "none" }}>
                      <td style={{ padding: "8px", fontSize: "15px" }}>
                        <strong> Date</strong>
                      </td>
                      <td style={{ padding: "8px", fontSize: "15px" }}>
                        :{" "}
                        {new Date(
                          studentInfo?.installmentsPaid?.[studentInfo?.installmentsPaid?.length - 1]
                            ?.sessionDate
                        ).toLocaleDateString("en-GB")}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <TableContainer component={Paper} style={{ marginBottom: "20px" }}>
              <Table sx={{ width: "100%" }} aria-label="spanning table">
                <TableHead>
                  <TableRow>
                    <TableCell>Description</TableCell>

                    <TableCell align="right">Amount</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow>
                    <TableCell>
                      Being payment for:
                      <br />
                      <i>
                        <b>
                          {installmentCountText} Installment ${" "}
                          {lastCourseDetail.amount.toFixed(2)}
                        </b>
                      </i>
                      <br />
                      <b>
                        <i>(Inclusive of GST 9% - ${getwithnum})</i>
                      </b>
                      <br />
                      Payment Fees Due Date:
                      <br />
                      Balance of Fees: $ {balanceDue} <br />
                      {lastCourseDetail.remainingBalance > 0 ? (
                        <>
                          Installment Fees Due Date: {lastInstallment}
                          {getOrdinalSuffix(lastInstallment)} Balance,
                          {lastInstallment + 1}
                          {getOrdinalSuffix(lastInstallment + 1)} Installment
                        </>
                      ) : (
                        //   <>
                        //     Installment Fees Due Date:{lastInstallment + 1}
                        //     {getOrdinalSuffix(lastInstallment + 1)} Installment
                        //   </>
                        // )}
                        <>
                          {(lastInstallment + 1 === 13 && studentInfo.type === "diploma") ? (
                            <>
                              Installment Fees Due Date: -
                            </>
                          ) : (lastInstallment + 1 === 7 && studentInfo.type === "advance_diploma") ? (
                            <>
                              Installment Fees Due Date: -
                            </>
                          ) : (
                            <>
                              Installment Fees Due Date: {lastInstallment + 1}
                              {getOrdinalSuffix(lastInstallment + 1)} Installment
                            </>
                          )}
                        </>
                      )}
                    </TableCell>

                    <TableCell align="right">
                      $
                      {studentInfo?.courseFeeDetails[
                        studentInfo?.courseFeeDetails.length - 1
                      ].amount.toFixed(2)}
                    </TableCell>
                  </TableRow>

                  <TableRow style={{ backgroundColor: "#f2f2f2" }}>
                    <TableCell align="left">
                      Sum of Dollars:{" "}
                      <strong>
                        {toUpperCaseString(`${sumOfDollarsCourseFee} DOLLAR ONLY`)}
                      </strong>
                    </TableCell>

                    <TableCell align="right">
                      <b>
                        $
                        {studentInfo?.courseFeeDetails[
                          studentInfo?.courseFeeDetails.length - 1
                        ].amount.toFixed(2)}
                      </b>
                    </TableCell>
                  </TableRow>
                  {/* <TableRow>
                    <TableCell colSpan={2}>
                      Name:<strong>{toUpperCaseString(studentInfo.approver)}</strong>
                    </TableCell>
                    <TableCell>
                      Signature:
                    </TableCell>
                  </TableRow> */}
                </TableBody>
              </Table>
            </TableContainer>

            <Button
              variant="contained"
              color="primary"
              startIcon={<DownloadIcon />}
              onClick={handlePdfEdit1}
              style={{
                padding: "10px 20px",
                fontSize: "16px",
                borderRadius: "8px",
              }}
            >
              Download Receipt
            </Button>
          </div>
        </div>
      )}
    </div>
  );
};

export default InvoiceStudent;
